import React, { useState } from "react"
import { mutationRequest } from "../../util/request"
import { Button } from "../../components/shared/Button"

interface UserPaymentSectionProps {
  userId: number
  hasPaymentMethod: boolean
  lastFour: string | null
}

export const UserPaymentSection: React.FC<UserPaymentSectionProps> = ({
  userId,
  hasPaymentMethod,
  lastFour,
}) => {
  const [removed, setRemoved] = useState(false)
  const [isRemoving, setIsRemoving] = useState(false)
  const [error, setError] = useState("")

  const handleRemove = async () => {
    if (
      !window.confirm(
        "Remove your saved card? You'll need to re-enter it for future purchases.",
      )
    )
      return
    setIsRemoving(true)
    setError("")
    try {
      const result = await mutationRequest({
        path: `/api/v1/users/${userId}/payment_method`,
        options: { method: "DELETE" },
      })
      if (result?.success) {
        setRemoved(true)
      } else {
        setError("Something went wrong. Please try again.")
      }
    } catch {
      setError("Something went wrong. Please try again.")
    } finally {
      setIsRemoving(false)
    }
  }

  const showCard = hasPaymentMethod && lastFour && !removed

  return (
    <>
      <h2 className="lg:col-span-8 col-span-12 font-bold border-b mb-4 border-black text-2xl leading-none uppercase mt-10">
        Payments
      </h2>
      {showCard ? (
        <div>
          <div className="flex items-center gap-4">
            <span className="text-gray-800 text-sm">
              Card ending in <span className="font-bold">{lastFour}</span>
            </span>
            <button
              onClick={handleRemove}
              disabled={isRemoving}
              className="text-xs px-2 py-0.5 border border-red-500 text-red-500 bg-white rounded hover:bg-red-50 disabled:opacity-50 focus:outline-none"
            >
              {isRemoving ? "Removing Card..." : "Remove Card"}
            </button>
          </div>
          <div className="text-xs text-gray-600">
            your credit card details are not stored on bandNada, they are only
            stored on our payment processor{" "}
            <a
              href="https://stripe.com/"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Stripe
            </a>
          </div>
        </div>
      ) : (
        <p className="text-gray-600 text-sm">
          No payment methods saved for this account.
        </p>
      )}
      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
    </>
  )
}
